module.exports = __webpack_public_path__ + "img/Stairs_icon.31159d1f.png";